import * as React from 'react'
import TabBar from '../../ui/entity/EntityTabBar'
import TabBarItem from '../../ui/entity/EntityTabBarItem'
import { Link } from 'react-router-dom'

enum viewVehicleNavRoutes {
  VEHICLE_DETAILS = 'details',
  PROVIDERS_PRODUCTS = 'providers-products',
  PRODUCTS = 'products',
  ACCESS_CAPACITY = 'access-capacity',
  ACCOMMODATIONS = 'accommodations'
}

const ViewVehicleNav = (props: { currentPath: string; pathname: string; vehicleId: string }) => {
  const isActiveLink = (linkPath?: string) => {
    const fullLink = linkPath ? `${props.currentPath}/${linkPath}` : props.currentPath
    return fullLink === props.pathname
  }

  return (
    <div className='mt1 tab-selector'>
      <TabBar>
        <TabBarItem active={isActiveLink(viewVehicleNavRoutes.VEHICLE_DETAILS)}>
          <Link to={`${props.currentPath}/details`}>Vehicle Details</Link>
        </TabBarItem>
        <TabBarItem active={isActiveLink(viewVehicleNavRoutes.PRODUCTS)}>
          <Link to={`${props.currentPath}/products`}>Products</Link>
        </TabBarItem>
        <TabBarItem active={isActiveLink(viewVehicleNavRoutes.ACCESS_CAPACITY)}>
          <Link to={`${props.currentPath}/access-capacity`}>Access & capacity</Link>
        </TabBarItem>
        <TabBarItem active={isActiveLink(viewVehicleNavRoutes.ACCOMMODATIONS)}>
          <Link to={`${props.currentPath}/accommodations`}>Accommodations</Link>
        </TabBarItem>
      </TabBar>
    </div>
  )
}

export default ViewVehicleNav



// WEBPACK FOOTER //
// ./src/components/vehicles/viewVehicle/ViewVehicleNav.tsx